import { render } from "./FormEspecialidade.vue?vue&type=template&id=64283bc2"
import script from "./FormEspecialidade.vue?vue&type=script&lang=js"
export * from "./FormEspecialidade.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__